import { E as ErrorTrackingClient } from './client-DHPkVy2U.js';
import { jsx } from 'react/jsx-runtime';
import { createContext, useMemo, useContext } from 'react';
import { getSession } from '@squareup/service-session';
import '@sentry/react';
import '@squareup/util-environment';
import '@squareup/service-one-trust';

const ErrorTrackingContext = createContext(null);
function ErrorTrackingProvider(props) {
  const { client, children, session } = props;
  const localSession = useMemo(() => session || getSession(), [session]);
  useMemo(() => {
    if (localSession) {
      const { merchantToken, employmentToken } = localSession;
      client.setUser({
        id: merchantToken,
        merchantToken,
        employmentToken
      });
      if (merchantToken) {
        client.setTags({ merchantToken });
      }
    }
  }, [client, localSession]);
  return /* @__PURE__ */ jsx(ErrorTrackingContext.Provider, { value: client, children });
}
const useErrorTracking = () => {
  const errorTrackingClient = useContext(ErrorTrackingContext);
  if (!errorTrackingClient) {
    throw new Error("The useErrorTracking hook must be used within a ErrorTrackingProvider.");
  }
  return useMemo(() => ({
    // this is a workaround to ensure that methods are bound to the
    // errorTrackingClient instance that way you can call use
    // `const { captureException } = useErrorTracking()`.
    // optional chaining is used to help testing mock instances without having
    // to mock the `ErrorTrackingClient` instance.
    // TODO: remove optional chaining once we have a better way to mock this hook.
    captureException: errorTrackingClient?.captureException?.bind(errorTrackingClient),
    captureMessage: errorTrackingClient?.captureMessage?.bind(errorTrackingClient),
    scope: errorTrackingClient?.scope
  }), [errorTrackingClient]);
};

let globalErrorTrackingClient;
function getGlobalErrorTrackingClient({
  environment,
  session
} = {}) {
  if (!globalErrorTrackingClient) {
    globalErrorTrackingClient = new ErrorTrackingClient({
      environment,
      session
    });
  }
  return globalErrorTrackingClient;
}

export { ErrorTrackingClient, ErrorTrackingContext, ErrorTrackingProvider, getGlobalErrorTrackingClient, useErrorTracking };
